import { Color, Tooltip } from '@mui/material'
import { MoreIcon } from '../../icons'
import { IconButton } from './IconButton'
import { ButtonSize } from './button.model'

interface Props {
  tooltip: string
  size?: ButtonSize
  testId?: string
  fill?: string | Color
  noPadding?: boolean
  customIcon?: React.ReactNode
  onClick: (e: React.MouseEvent) => void
}
export const MoreOptionsButton = ({
  fill,
  noPadding,
  tooltip,
  size,
  testId,
  onClick,
  customIcon,
}: Props) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton
        sx={noPadding ? { padding: 0 } : {}}
        data-cy={testId}
        color='default'
        fill={fill}
        size={size ?? 'medium'}
        onClick={onClick}
      >
        {customIcon ?? <MoreIcon fontSize={size ?? 'medium'} />}
      </IconButton>
    </Tooltip>
  )
}
